import _ from "lodash";

const postProcessAxiosFunctions = {
	JsonOptions: (response) =>
		response && "JsonOptions" in response ? response.JsonOptions : response,

	JSONParse: (response) =>
		response && _.isString(response) ? JSON.parse(response) : response,

	convertLabels: (response) =>
		_.isArray(response)
			? response.map(({ Value, Description }) => {
					return { label: Description, value: Value };
			  })
			: undefined,

	VehicleSearch: (response, policyType) => {
		// console.log("ddddd:", response)
		if (!response) return [];
		if (!_.isArray(response.FoundVehicles)) return [];

		// const VehicleType = (function () {
		// 	if (policyType === "PC") return "Car";
		// 	if (policyType === "GV") return "Van";
		// 	return undefined;
		// })();

		const DefaultValues = (function () {
			if (!response.DefaultValues) return {};

			if (_.isArray(response.DefaultValues)) return response.DefaultValues[0];

			return response.DefaultValues;

			// if (_.isArray(response.DefaultValues))
			// 	return response.DefaultValues.find(
			// 		(x) => x.VehicleType === VehicleType
			// 	);

			// if (response.DefaultValues.VehicleType === VehicleType)
			// 	return response.DefaultValues;

			// return {};
		})();

		const returnList = response.FoundVehicles.map((x) => {
			const { VehicleType: _vehicleType, ..._defaultValues } = DefaultValues;

			let baseReturnValue = {
				value: JSON.stringify({
					..._defaultValues,
					...x,
					AbiProductionYears: `${x.StartYear} - ${
						x.EndYear == 0 ? "Present" : x.EndYear
					}`,
				}),

				//AbiDescription BodyStyle EngineSize FuelType StartYear EndYear
			};

			switch (policyType) {
				case "PC": {
					baseReturnValue.label = `${x.AbiDescription} ${x.BodyStyle} ${x.EngineSize}cc (${x.NumberOfDoors} door)`;
					break;
				}
				case "GV": {
					baseReturnValue.label = `${x.AbiDescription} ${x.BodyStyle} ${x.EngineSize}cc`;
					break;
				}
			}
			return baseReturnValue;
		});

		// console.log("ddd", "response", response, "returnList:", returnList);
		return returnList;
	},

	mergeItems: (items) => (response) =>
		response ? [...items, ...response] : undefined,
	arrayToObject: (response = []) => {
		let retObj = {};
		response.forEach(({ value, label }) => {
			retObj[value] = label;
		});
		return retObj;
	},
	manualManufacturer: (response = []) => {
		if (!_.isArray(response)) return [];

		const retList = response.map(
			({ Value: value, Value: label, ListOptions }) => {
				return {
					value,
					label,
					options: (ListOptions || []).map(
						({ Value: value, Value: label }) => ({
							value,
							label,
						})
					),
				};
			}
		);

		// console.log("retList", retList);
		return retList;
	},
	arrayToObjectGroup: (response = []) => {
		let retObj = {};
		response
			.flatMap(({ options }) => options)
			.forEach(({ value, label }) => {
				retObj[value] = label;
			});
		return retObj;
	},
	splitByCategory: (response) => {
		if (!response) return undefined;
		if (!_.isArray(response)) return undefined;

		const newData = response.map(({ Description: label, ListOptions }) => {
			return {
				label,
				options: ListOptions.map(({ Value: value, Description: label }) => {
					return { value, label };
				}),
			};
		});
		return newData;
	},
	title: (response) => {
		if (!_.isArray(response)) return [];

		return response.map((item) => {
			const splitData = item.value.split("-");
			if (splitData.length !== 2)
				throw `Error in webservice getTitle -- received data that doesn't contain a "dash" : ${value}`;
			const title = splitData[0];
			const gender = splitData[1];
			const newValue = JSON.stringify({ title, gender });

			return { ...item, value: newValue };
		});
	},
};

export default postProcessAxiosFunctions;
